const countFormat = new Intl.NumberFormat('fr-FR');

/** Exact integer with the French thousands separator. */
const formatCount = (count: number): string => countFormat.format(count);

export default formatCount;
